import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import merge from 'lodash/merge';
import connect from './account.connector';
import MosaicGrid from '../../tornado/templates/blocks/mosaicGrid/mosaicGrid.component';
import { removeSplashScreen } from '../../../logic/app/app.utils';
import { filterNavigationEntries, makeProfilesGateAction } from './account.utils';
import { getInitialStyle, defaultContext, GRID_MARGIN_TOP } from './account.style';
import { createItemAction } from '../../cta/cta.actions';
import { SELECTED_SIGNAL } from '../../tornado/signals';
import { CONTENT_GAP as MOSAIC_GRID_GAP } from '../../tornado/templates/blocks/mosaicGrid/mosaicGrid.constant';
import { ITEMS_PER_ROW } from '../../tornado/templates/blocks/mosaicGrid/mosaicGrid.style';
import UserInfoBar from '../../userInfoBar/userInfoBar.component';
import DeviceInfoBar from '../../deviceInfoBar/deviceInfoBar.component';
import { SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { CHANGE_PROFILE_SIGNAL } from './account.constants';
import { AccountCard } from './accountCard/accountCard.component';
import { MOSAIC_CARD_SIZE } from './accountCard/accountCard.style';

export class Account extends Lightning.Component {
  static _template() {
    return merge(
      {
        Background: {
          rect: true,
        },
        ProfileInfo: {},
        UserInfoBar: {
          type: UserInfoBar,
          signals: {
            [CHANGE_PROFILE_SIGNAL]: '_handleChangeProfile',
          },
        },
        Grid: {
          type: MosaicGrid,
          signals: {
            [SELECTED_SIGNAL]: '_handleSelected',
          },
        },
        DeviceInfo: {
          type: DeviceInfoBar,
        },
      },
      getInitialStyle(),
    );
  }

  static _states() {
    return [
      class Grid extends this {
        _getFocused() {
          return this.tag('Grid');
        }
      },
      class InfoBar extends this {
        _getFocused() {
          return this.tag('UserInfoBar');
        }
      },
    ];
  }

  _construct() {
    this._navigation = null;
    this._isProfileSelected = null;
    this._style = defaultContext;
  }

  _active() {
    removeSplashScreen();
  }

  _attach() {
    this._unsubscribe = connect(this);
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set navigation(value) {
    if (!value || this._navigation === value) {
      return;
    }

    this._navigation = value;
    this._fillGrid(filterNavigationEntries(value, Store.getState()));
  }

  set profileUsername(value) {
    if (!value) {
      return;
    }
    this.tag('UserInfoBar').userName = value;
  }

  set profilePhotoId(value) {
    this.tag('UserInfoBar').photoId = value;
  }

  set selectedProfile(value) {
    this._isProfileSelected = Boolean(value);
    this.tag('UserInfoBar').visible = this._isProfileSelected;
  }

  _fillGrid(items) {
    if (!items) {
      this._setState('InfoBar');

      return;
    }

    const { screenSize } = this._style;
    const rowsCount = Math.ceil(items.length / ITEMS_PER_ROW[screenSize]);
    const itemSize = MOSAIC_CARD_SIZE[screenSize];
    const gap = MOSAIC_GRID_GAP[screenSize];
    const mosaicHeight = rowsCount * (itemSize.h + gap) - gap;
    const mosaicContainerHeight = SCREEN_HEIGHT[screenSize];

    this.tag('Grid').patch({
      y: Math.max(Math.round((mosaicContainerHeight - mosaicHeight) / 2), GRID_MARGIN_TOP[screenSize]),
      data: {
        items,
        itemType: AccountCard,
        itemSize,
      },
      signals: {
        [SELECTED_SIGNAL]: '_handleSelected',
      },
    });

    this._setState('Grid');
  }

  _handleUp() {
    if (this._isProfileSelected) this._setState('InfoBar');

    return true;
  }

  _handleDown() {
    if (this.state === 'InfoBar') {
      this._setState('Grid');
    }

    return true;
  }

  _handleSelected(item) {
    Store.dispatch(createItemAction({ item: { ...item, action: item } }));
  }

  _handleChangeProfile() {
    Store.dispatch(createItemAction(makeProfilesGateAction()));
  }
}
